module.exports = __webpack_public_path__ + "static/img/folia.d4f6cc3a.png";